import { Container } from "aurelia-dependency-injection";
import { AppEvents } from "./../../../app-events";
import { SearchModel } from "./../../models/search";
import { AdvancedSearchFormModel } from "./../../models/advanced-search-form";
import { backboneViewProperties } from "./../../../decorators/backbone-properties";
import { AdvancedSearchModel } from "./../../models/advanced-search";
import {AdvancedSearchFormView} from "./advanced-search-form";
import { ContainerHelper } from "../../../shared/helpers/container-helper";

const template = require<string>("./advanced-search-forms.html");

const dom = {
    FORM_CONTROLS_NAV: ".controls-nav",
    FORM_CONTROLS_BUTTON: ".eu-form-control",
};

@backboneViewProperties({
    template
})
export class AdvancedSearchView extends Marionette.LayoutView<AdvancedSearchModel> {
    private formRegion: Marionette.Region;
    private appEvents: Backbone.Events;

    constructor(options?) {
        super(options);
        this.appEvents = ContainerHelper.Events;
        this.setupModelListeners();
    }

    public setupModelListeners() {
        this.listenTo(this.model, "change:ActiveForm", this.activeFormChanged);
    }

    public onShow() {
        this.showControls();
        this.showForm();
    }

    public events(): Backbone.EventsHash {
        const events: Backbone.EventsHash = {};
        events["click " + dom.FORM_CONTROLS_BUTTON] = (e) => this.formControlClick(e);
        return events;
    }

    public regions(): any {
        const regions = {
            formRegion: ".forms-region"
        };
        return regions;
    }

    public formControlClick(e: JQueryEventObject): void {
        const formID = this.$(e.currentTarget).data("form-id");
        this.model.selectForm(formID);
        Backbone.history.navigate("advancedsearch/" + formID, {trigger: true});
    }

    public showControls() {
        this.model.SearchForms.each((f: AdvancedSearchFormModel) => {
            const li = `<li class="eu-form-control" data-form-id="${f.Identifier}">${f.Label}</li>`;
            this.$(dom.FORM_CONTROLS_NAV).append(li);
        });
    }

    public activeFormChanged(model, prop) {
        if (this.model.Loaded) {
            this.model.trigger("FilterChanged");
            this.model.trigger("KeyPressed");
            this.showForm();
        }
    }

    public showForm() {
        if (this.model.Loaded && this.model.ActiveForm) {
            this.$(dom.FORM_CONTROLS_BUTTON).removeClass("active");
            this.$(".eu-form-control[data-form-id=" + this.model.ActiveForm.Identifier + "]").addClass("active"); // select on data-form-id

            this.formRegion.show(new AdvancedSearchFormView({model: this.model.ActiveForm}));

            $(".forms-region").scroll(() => {
                this.scrolled();
            });
            $(window).resize(() => {
                this.scrolled();
            });
        }
    }

    private scrolled(): void {
        this.model.trigger("scrolled");
    }

}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/search/views/advanced-search/advanced-search.ts